import { convertExpression } from './entities/convertExpressionLevel.js';
import { convertTermLevel } from './entities/convertTermLevel.js';
import { convertAtomLevel } from './entities/convertAtomLevel.js';
export const schemaConversion = (expression, dependencies) => {
    // Create the base convertedExpression
    const convertedExpression = convertExpression(expression, dependencies);
    // Convert the Terms of the expression
    convertTermLevel(expression.terms, convertedExpression, dependencies);
    // Go over each term atoms for conversion
    Object.values(convertedExpression.terms).forEach((term, index) => {
        const dbTerm = expression.terms[index];
        term.atoms = dbTerm.atoms.reduce((atomsMapper, currentAtom, currentIndex) => {
            // Set converted atom with its index
            atomsMapper[`A${currentIndex + 1}`] = convertAtomLevel(currentAtom, dependencies);
            return atomsMapper;
        }, {});
    });
    return convertedExpression;
};
//# sourceMappingURL=schemaConversion.js.map